import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=7c63a38a&scoped=true&"
import script from "./Inicio.vue?vue&type=script&lang=js&"
export * from "./Inicio.vue?vue&type=script&lang=js&"
import style0 from "./Inicio.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Inicio.vue?vue&type=style&index=1&id=7c63a38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63a38a",
  null
  
)

export default component.exports